class LectorProximidad {

  constructor (urlBaseComponenteLectorProximidad) {
    if (urlBaseComponenteLectorProximidad)
      this.urlBaseComponenteLectorProximidad = urlBaseComponenteLectorProximidad;
    else
      this.urlBaseComponenteLectorProximidad = "http://127.0.0.1:7777"; // "https://127.0.0.1:7778" (hay que ir a "avanzado" -> "Continuar a 127.0.0.1 (no seguro)")
  }

  leerNumeroSerie (timeout_ms) {
    return new Promise ( (resolve, reject) => {
      if (window.XMLHttpRequest) {
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function() {
          if (xmlhttp.readyState == 4) {
            if (xmlhttp.status == 200) {
              let json = JSON.parse (xmlhttp.responseText);
              resolve (json.serial_number);
            } else {
              reject ();
            }
          }
        }
        xmlhttp.open ("GET", `${this.urlBaseComponenteLectorProximidad}/api/contactless/serialnumber?timeout=${timeout_ms}`, true);
        xmlhttp.send ("");
      }
    });
  }

}

export default new LectorProximidad(); // exportamos una unica instancia del objeto (misma instancia alla donde se importe este módulo)